// @ts-nocheck
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const AspirantatUchitelyuDePerebuvayesh = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  return (
    <>
      <div className="container max-w-screen-lg pt-3 pb-3 ">
        <h1 className="py-3 text-3xl md:text-5xl font-bold text-[#A81414] ">Аспірантат</h1>
        <div className="text-justify hyphens-auto" id="section2">
          <div className="pt-3 pb-3 border-l-4 border-[#A81414] pl-6">
            <div className="italic">
              «Почули двоє учнів, як він оте сказав, та й пішли за Ісусом. Обернувшися ж Ісус і побачивши, що вони йдуть, мовив до них: «Чого шукаєте?» Ті ж йому: «Равві, - що в перекладі означає: Учителю, - де перебуваєш?» Відрік він їм: «Ходіть та подивіться.» Пішли, отже, і побачили, де перебуває, і того дня залишилися в нього. Було ж близько десятої години».
            </div>
            (Ів 1,37-39).
          </div>
          <div className="pt-3 pb-3">
            Салезіяни, відповідаючи на потреби Церкви, проголошують Євангеліє найбільш убогій і занедбаній молоді через душпастирське служіння.
          </div>
          <div className="pt-3 pb-3">
            Після періоду розпізнання покликання кандидат, який бажає глибше пізнати салезіянське життя, вступає до аспірантату — етапу, що допомагає зміцнити покликання та перевірити готовність служити Богові й молоді. Провінційний настоятель скеровує кандидата до однієї зі спільнот Провінції та призначає відповідального співбрата, який супроводжує його в цьому процесі.
          </div>
          <div className="pt-3 pb-3">
            Аспірантат зазвичай триває шість місяців, але може бути продовжений до одного року чи більше. Протягом цього часу кандидати поглиблюють знайомство з духовністю, харизмою і місією святого Івана Боско, беруть участь у пасторальних ініціативах спільноти, навчаються італійської мови та інших дисциплін, потрібних для подальшої формації.
          </div>
          <div className="pt-3 pb-3">
            Можливо, і до тебе, дорогий юначе, Ісус звертається цими словами — кличе й запрошує йти за Ним особливим шляхом посвяти. Може, саме тебе Він хоче послужитися, щоб нести Його любов і Слово тим, хто цього найбільше потребує. Ісус кличе — а відповідь залежить від тебе.
          </div>
          <br /> <br />
          <div className="text-[#A81414] font-semibold">
            Душпастирство покликань
          </div>
          <div className="text-[#A81414] font-semibold">
            Провінція Марії Помічниці Християн
          </div>
          <div className="text-[#A81414] font-semibold">
            вул. Личаківська, 175
          </div>
          <div className="text-[#A81414] font-semibold">
            місто Львів
          </div>
          <div className="text-[#A81414] font-semibold">
            Провінційний Настоятель, отець Михайло Чабан, СДБ
          </div>
          <div className="text-[#A81414] font-semibold">
            Тел: +38 067 889 07 70
          </div>
        </div>
      </div>
    </>
  );
};

export default AspirantatUchitelyuDePerebuvayesh;
